<ul class="list-group comm-list">
    @for (comm of communications; track comm.id; let index = $index) {
        <li class="list-group-item">
            @if (!comm.editing) {
                <span class="material-icons icon" [ngClass]="{'primary': comm.primary}">{{commIcon(comm.type)}}</span>
                <div class="meta" (click)="editComm($event, index)">
                    <p class="title">
                        {{commDisplay(comm)}}
                        @if (comm.subtype) {
                            <span class="text-muted">({{comm.subtype}})</span>
                        }
                    </p>
                </div>
                <div class="actions actions-1">
                    <span class="dripicons-trash text-danger" (click)="discardComm($event, index)"></span>
                </div>
            }
            @else {
                <form [formGroup]="commEdit">
                    <div class="form-row">
                        <div class="form-group col">
                            <select class="form-control form-control-sm" formControlName="type">
                                @for (type of commTypes; track type) {
                                    <option value="{{type}}">{{type}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-xs-3">
                            <select class="form-control form-control-sm" formControlName="subtype">
                                @for (type of commSubTypes; track type) {
                                    <option value="{{type}}">{{type}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control form-control-sm" formControlName="value" placeholder="value" />
                    </div>
                    <div class="form-row">
                        <div class="form-check col">
                            <input type="checkbox" id="commPrimary" class="form-check-input" formControlName="primary" />
                            <label class="form-check-label" for="commPrimary">Primary</label>
                        </div>
                        <div class="actions col">
                            <button type="button" class="btn btn-sm btn-link" (click)="cancelComm($event)"><span class="text-danger">cancel</span></button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="saveComm($event)">Save</button>
                        </div>
                    </div>
                </form>
            }
        </li>
    }
</ul>
<button (click)="addComm($event)" title="Add Communication" class="btn btn-sm btn-success add"><span class="uil-plus"></span></button>